import { UTCDate } from '@date-fns/utc';
import { format as fnsFormat } from 'date-fns';
export const format = (date) => {
    if (!date) {
        return;
    }
    return fnsFormat(new UTCDate(date), 'MM/dd/yyyy');
};
const mapM0100 = {
    '01': 'soc',
    '03': 'roc',
    '04': 'rct',
    '05': 'ofu',
    '06': 'tr',
    '07': 'trd',
    '08': 'dth',
    '09': 'dsch',
};
export const isActive = (field, vIn, tIn) => {
    if (!vIn || !tIn) {
        return false;
    }
    else if ((field.version.includes(vIn) || field.version.includes('*')) &&
        (field.timepoint.includes(mapM0100[tIn]) || field.timepoint.includes('*'))) {
        return true;
    }
    else {
        return false;
    }
};
export const isTimepoint = (values, m0100) => {
    if (!m0100) {
        return false;
    }
    else if (values.includes(m0100)) {
        return true;
    }
    return false;
};
export function fieldSetValidate({ input, ifChecked, notChecked }) {
    if (!input || !input.length) {
        return true;
    }
    const checked = input.some((item) => ifChecked.includes(item));
    if (checked) {
        return !notChecked.every((item) => !input.includes(item));
    }
    return false;
}
